import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../core/_config/app.config';

@Injectable({
    providedIn: 'root',
})
export class FinancialAgreementService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    getFinancialAgreements(): Observable<any> {
        return this.http.get(`${this.API_URL}FinancialAgreements`);
    }

    getFinancialAgreementOnlineCreditCard(legalEntityId: string): Observable<any> {
        return this.http.get(`${this.API_URL}FinancialAgreements/GetFinancialAgreementOnlineCreditCard/${legalEntityId}`);
    }
}
